import Colors from 'constants/Colors';

export default {
  header: {
    display: 'flex',
    flexDirection: 'column',
    marginTop: 16,
    justifyContent: 'space-between',
    gap: 8,
    paddingRight: 32,
  },

  langSelectorContainer: {
    display: 'flex',
    marginLeft: 32,
    gap: 8,
    alignItems: 'center',
    height: 32,
  },

  contentWrapper: {
    padding: '2rem',
    borderRadius: '1rem',
  },

  sectionBox: {
    border: '1px solid #000',
    borderRadius: '1rem',
    padding: '1rem 1.5rem',
    backgroundColor: '#fff',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: '1rem',
    color: Colors.darkText,
  },

  sectionButton: {
    backgroundColor: '#f3f7ff',
    color: '#0040a0',
    padding: '0.5rem 1rem',
    borderRadius: '1rem',
    border: 'none',
    fontWeight: 'bold',
    cursor: 'pointer',
  },

  signatureContainer: {
    border: '1px solid #000',
    borderRadius: '1rem',
    padding: '1.5rem',
    backgroundColor: '#fff',
    marginBottom: '2rem',
  },

  signatureLabel: {
    display: 'block',
    marginBottom: '0.5rem',
    color: Colors.darkText,
  },

  signatureBox: {
    backgroundColor: '#f0f6ff',
    height: '150px',
    borderRadius: '1rem',
    position: 'relative',
  },

  disabledButton: {
    backgroundColor: '#ccc',
    color: '#fff',
    textAlign: 'center',
    borderRadius: '2rem',
    padding: '1rem',
    fontWeight: 'bold',
    cursor: 'not-allowed',
  },

  checkinFields: {
    border: '1px solid #000',
    borderRadius: '1rem',
    padding: '1.5rem',
    backgroundColor: '#fff',
    marginBottom: '2rem',
  },
  saveButtonContainer: {
    paddingTop: 10,
    display: 'flex',
    justifyContent: 'flex-end',
    paddingRight: 10,
  },
  previewButton: {
    marginTop: '10px',
    alignSelf: 'flex-end',
  },
};
